import { ATTACHMENT_STATUSES } from '@/constants'

export const getVisibleRejectedReplacementCandidate = (attachment) => {
  if (attachment?.openReplacementCandidate?.id) return null

  return attachment?.latestRejectedReplacementCandidate || null
}

export const getReplacementStatusChipValue = (attachment) => {
  if (attachment?.openReplacementCandidate?.id) {
    return attachment.openReplacementCandidate.status === ATTACHMENT_STATUSES.approved
      ? 'replacement_scheduled'
      : 'replacement_pending'
  }

  if (getVisibleRejectedReplacementCandidate(attachment)?.id) {
    return 'replacement_rejected'
  }

  return null
}

export const getVisibleAttachmentComment = (attachment) => {
  return getVisibleRejectedReplacementCandidate(attachment)?.reviewComment ||
    attachment?.comment?.body ||
    '-'
}
